<template>
  <action-modal-wizard
    ref="modal"
    title="Payoff Request"
    modalIdPrefix="payoff-"
    size="lg"
    :loan="loan"
    @form-completed="submit"
    @modal-hidden="onModalHidden"
  >
    <tab-content :title="`Escrow Information`" :before-change="validateForm">
      <payoff-form ref="payoffForm" />
    </tab-content>

    <tab-content title="Additional Files">
      <additional-files-form
        ref="additionalForm"
        headline="
          If there is anything else you would like to share
          with us regarding your loan status, please share below.
        "
      />
    </tab-content>
  </action-modal-wizard>
</template>

<script>
import helper from '@/libs/helper';

import { TabContent } from 'vue-form-wizard';
import ActionModalWizard from '@/components/my_deals/actions/ActionModalWizard';
import PayoffForm from '@/components/my_deals/actions/payoff/PayoffForm';
import AdditionalFilesForm from '@/components/my_deals/actions/AdditionalFilesForm';

export default {
  components: {
    TabContent,
    ActionModalWizard,
    PayoffForm,
    AdditionalFilesForm,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onModalHidden() {
      this.$refs.payoffForm.resetModel();
      this.$refs.additionalForm.reset();
    },
    validateForm() {
      return this.$refs.payoffForm.validate();
    },
    submit() {
      const data = [];
      data.form = helper.copy(this.$refs.payoffForm.model);
      this.$refs.additionalForm.model.files.forEach(file => data.push(file));

      /* eslint no-underscore-dangle:  ["error", { "allow": ["_id"] }] */
      this.$reqs.uploadAssetManagement(`/users/${this.$store.getters.user.id}/loans/${this.loan._id}/payoff`, data)
        .then((response) => {
          this.$notify({ group: 'alert', text: 'Payoff Request saved successfully.' });
          this.$emit('payoff-sent', response);
          this.hide();
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/payoff/PayoffWizardModal.vue